@if((isLoading$ | async) && spinnerType() === 'global') {
<div class="overlay">
  <span class="loader"></span>
</div>
}

@if((isLoadingUserData$ | async) && spinnerType() === 'userData') {
<div class="container top-user-blue back-user visible" style="height: auto;">
  <div class="row">
    <div class="col-lg-12">
      <div class="container">
        <div class="row justify-content-center mb-4">
          <div class="col-12 col-md-3 text-center">
            <img [src]="undefined | placeholderIfEmpty" alt="" class="insignia profile-rounded">
          </div>
          <div class="col-12 col-md-9">
            <div class="d-flex align-items-center justify-content-center h-100">
              <div class="progress w-100" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100">
                <div class="progress-bar progress-bar-striped progress-bar-animated" style="width: 75%"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
}